import{Z as o,d as s}from"./p-VjIFWKCr.js";const r=o;const t=s;export{r as ZprDropdownMenu,t as defineCustomElement};
//# sourceMappingURL=zpr-dropdown-menu.js.map